/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Error_Code_GeneralInputs */

const en_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error Code: ${i?.status}. Please contact support in the app.`)
};

const ar_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`كود الخطأ: ${i?.status}. يرجى الاتصال بالدعم في التطبيق.`)
};

const de_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehlercode: ${i?.status}. Bitte kontaktieren Sie den Support in der App.`)
};

const es_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código de error: ${i?.status}. Ponte en contacto con el servicio de asistencia de la app.`)
};

const fr_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code d'erreur: ${i?.status}. Veuillez contacter le support.`)
};

const it_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codice di errore: ${i?.status}. Ti preghiamo di contattare il supporto nell'app.`)
};

const ja_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エラーコード：${i?.status}。アプリ内のサポートにお問い合わせください。`)
};

const ko_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`오류 코드: ${i?.status}. 앱에서 고객센터로 연락하세요.`)
};

const pt_br_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código de erro: ${i?.status}. Entre em contato com o suporte no aplicativo.`)
};

const ru_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Код ошибки:${i?.status}. Cвяжитесь с поддержкой в приложении.`)
};

const th_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รหัสข้อผิดพลาด: ${i?.status} โปรดติดต่อฝ่ายสนับสนุนในแอป`)
};

const tr_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hata Kodu ${i?.status}. Lütfen uygulamada destek hattıyla iletişime geç.`)
};

const zh_cn_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`错误代码：${i?.status}，请在 App 內联系客服。`)
};

const zh_tw_error_code_general = /** @type {(inputs: Error_Code_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`錯誤代碼：${i?.status}，請回到 App 聯繫客服。`)
};

/**
* | output |
* | --- |
* | "Error Code: {status}. Please contact support in the app." |
*
* @param {Error_Code_GeneralInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const error_code_general = /** @type {((inputs: Error_Code_GeneralInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Code_GeneralInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_code_general(inputs)
	if (locale === "ar") return ar_error_code_general(inputs)
	if (locale === "de") return de_error_code_general(inputs)
	if (locale === "es") return es_error_code_general(inputs)
	if (locale === "fr") return fr_error_code_general(inputs)
	if (locale === "it") return it_error_code_general(inputs)
	if (locale === "ja") return ja_error_code_general(inputs)
	if (locale === "ko") return ko_error_code_general(inputs)
	if (locale === "pt_br") return pt_br_error_code_general(inputs)
	if (locale === "ru") return ru_error_code_general(inputs)
	if (locale === "th") return th_error_code_general(inputs)
	if (locale === "tr") return tr_error_code_general(inputs)
	if (locale === "zh_cn") return zh_cn_error_code_general(inputs)
	return zh_tw_error_code_general(inputs)
});